// extracted by mini-css-extract-plugin
module.exports = {"modal":"FormModal_modal__1pDaZ","error":"FormModal_error__o9LOx","buttons":"FormModal_buttons__7CWcJ","submitButton":"FormModal_submitButton__1soY_"};